<template>
  <div class="serviceMain">
    <div class="searchBar">
      <div class="tittle"> 我的查重 </div>
      <div class="rightForm">
        <el-input
          v-model="form.subject"
          placeholder="请输入作品名称"
        ></el-input>
        <el-date-picker
          v-model="form.date"
           value-format="yyyy-MM-dd"
          type="date"
          placeholder="选择日期"
        >
        </el-date-picker>
       <el-button @click="fetchData">查询</el-button>
        <router-link :to="{path:'/DuplicateCheck'}">
            <el-button type="primary">新增查重</el-button>
        </router-link>
      </div>
    </div>

    <el-table
      :data="tableData"
      :cell-class-name="tabelCellClass"
      style="width: 100%"
      v-loading="isLoading"
    >
      <el-table-column
        prop="title"
        label="查重名称"
         show-overflow-tooltip
        width="160"
      >
      </el-table-column>
      <el-table-column
        prop="author"
        label="论文作者"
        show-overflow-tooltip
        width="100"
      >
      </el-table-column>
      <el-table-column
        prop="orderNo"
        label="订单号"
        width="170"
      >
      </el-table-column>
      <el-table-column
        prop="createTimeText"
        label="创建时间"
        sortable
        width="170"
      >
        <!-- eslint-disable-next-line -->
        <template slot="header" slot-scope="scope">
          <div class="createTimeHeader">
            <span>创建时间</span>
            <a-tooltip>
              <template slot="title">
                prompt text
              </template>
              <a-icon type="question-circle" />
            </a-tooltip>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="orderStatus"
        label="状态"
        width="85"
      >
        <template slot-scope="scope">
          <span
            class="stausCell"
            :class="{'stausCell1':scope.row.orderStatus=='31',
            'stausCell2':scope.row.orderStatus=='40',
            'stausCell3':scope.row.orderStatus=='11'|| scope.row.orderStatus=='12' || scope.row.orderStatus=='13' || scope.row.orderStatus=='20',
            'stausCell4':scope.row.orderStatus=='10',
            'stausCell5':scope.row.orderStatus=='21',}"
          >
            {{scope.row.statusText}}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="repetitionRate"
        label="重复率"
        width="85"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.repetitionRate">{{scope.row.repetitionRateText}}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <!-- <el-table-column
        prop="certificate"
        label="证书"
        width="180"
      >
        <template slot-scope="scope">
          <div class="signList">
            <span
              :class="{'graySpan':scope.row.orderStatus!='21','greenSpan':scope.row.orderStatus=='21'}" @click="getRegisterImg(scope.row.orderNo)"
            >
              登
              <i
                class="redBag"
                v-if="scope.row.orderStatus=='21'"
              > 1 </i>
            </span>
            <span
              :class="{'graySpan':scope.row.orderStatus!='21','greenSpan':scope.row.orderStatus=='21'}" @click="getExistImg(scope.row.extra.exist.orderNo)"
            >
              存
              <i
                class="redBag"
                v-if="scope.row.orderStatus=='21'"
              > 1 </i>
            </span>
          </div>

        </template>
      </el-table-column> -->
      <el-table-column
        label="操作"
        width="150"
        fixed="right"
      >
        <!-- eslint-disable-next-line -->
        <template slot-scope="scope">
          <!-- {{scope.row.status}} -->
               <!-- <a-dropdown
            :trigger="['click']"
            placement="bottomLeft"
            overlayClassName="moveLeft"
          >
            <a @click.stop="e => e.preventDefault()">
              <a-icon type="more" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                 <router-link :to="{path:'/DuplicateCheck',query: {index:2,orderNo: scope.row.orderNo}}"> 查看报告 </router-link>
              </a-menu-item>
              <a-menu-item>
                 <router-link :to="{path:'/DuplicateCheck'}"> 重新查重 </router-link>  
              </a-menu-item>
            </a-menu>
          </a-dropdown>
          <a-icon type="right" class="ml12 gray" @click="onTabelRowClick(scope.row)" /> -->
          
          <!-- <router-link class="myCheckBtn" v-if="scope.row.orderStatus=='21'" style="margin-right: 10px;" :to="{path:'/DuplicateCheck/detail',query: {comparison: scope.row.reportInfo.comparison}}"> 查看报告 </router-link> -->
          <!-- <router-link class="myCheckBtn" v-if="scope.row.orderStatus=='21'" style="margin-right: 10px;" :to="{path:'/DuplicateCheck/detail',query: {orderInfo: scope.row}}"> 查看报告 </router-link> -->
          <!-- <router-link class="myCheckBtn" v-if="scope.row.orderStatus=='21'" style="margin-right: 10px;" :to="{path:'/DuplicateCheck',query: {index:2,orderNo: scope.row.orderNo}}"> 查看报告 </router-link> -->
          <!-- <el-button class="myCheckBtn2" v-else style="margin-right: 10px;" disabled> 查看报告 </el-button> -->
          <el-button class="myCheckBtn" @click="download(scope.row.reportInfo.zip)" v-if="scope.row.orderStatus=='21'"> 下载报告 </el-button>
          <el-button class="myCheckBtn" @click="RepayAgain(scope.row)" v-if="scope.row.orderStatus=='10'"> 付款 </el-button>
          <el-button class="myCheckBtn" v-if="scope.row.orderStatus!='21' && scope.row.orderStatus!='10'" disabled> 下载报告 </el-button>
          <!-- <router-link class="myCheckBtn" :to="{path:'/DuplicateCheck'}"> 重新查重 </router-link>   -->
          <router-link class="myCheckBtn" v-if="scope.row.orderStatus=='21' && scope.row.repetitionRate<0.25" :to="{path:'/ComprehensiveInputForm',query: {formStep: '2',checkOrderNo: scope.row.orderNo}}"> DCI申领 </router-link>
          <el-button class="myCheckBtn" v-if="scope.row.orderStatus!='21' && scope.row.orderStatus!='10'" disabled> DCI申领 </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="total, sizes, prev, pager, next"
      :total="pagination.total"
      :current-page.sync="pagination.page"
      :page-size.sync="pagination.pageSize"
      :page-sizes="[10, 20, 30, 50]"
      @size-change="sizeChange"
      @current-change="currentChange"
      :pagerCount="5" 
    >
    </el-pagination>


      <!-- 图片预览 -->
      <el-image-viewer
        v-if="showImageViewer"
        :url-list="[showImageUrl]"
        hide-on-click-modal
        teleported
        :on-close="closePre"
      />
      <el-image-viewer
        v-if="showImageViewer2"
        :url-list="[showImageUrl2]"
        hide-on-click-modal
        teleported
        :on-close="closePre2"
      />

      <!-- 支付弹窗 -->
      <pay-dialog ref="payDialog" payForm="check" @close="onSetPayDialogClose"></pay-dialog>
  </div>
</template>

<script>
import PayDialog from "../../../components/PayDialog";
import {queryCheckOrderList,queryRegisterOrder,queryExistOrder,queryCheckPaymentOrder} from '@/api/EvidenceService'
export default {
  name: 'MyRegister',
  components: {
      'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer'),
      PayDialog
  },
  data () {
    return {
      form: {
         subject: null,
        date: null
      },
      isLoading: false,
      pagination: {
         total:0,
        page: 1,
        pageSize: 10
      },
      tableData:[],
      
      showImageViewer: false,
      showImageUrl: '',
      showImageViewer2: false,
      showImageUrl2: '',
    }
  },
  created() {
    this.fetchData();
  },
  activated() { // 每次进入页面时调用数据获取方法
    this.fetchData()
  },
  methods: {
    onTabelRowClick(row){
      this.$router.push({
        path: "/DuplicateCheck/Detail",
            query: {orderNo:row.orderNo}
      });
    },
    tabelCellClass ({ row, column, rowIndex, columnIndex }) {
      if (column.property == 'certificate') {
        return 'certificateCell'
      }
    },
    getStatus(code){
        switch(code){
          case '10':return '待付款';
          case '11':return '待审核';
          case '12':return '检测中';
          case '20':return '已审核';
          case '21':return '已完成';
          case '31':return '失败';
          case '40':return '已取消';
        }
    },
    fetchData (param) {
      this.isLoading = true
        queryCheckOrderList(this.pagination.page,this.pagination.pageSize,this.form).then(({data})=>{
            for (let i = 0; i < data.list.length; i++) {
            const element = data.list[i];
             element.num=element.items.length;
             element.statusText=this.getStatus(element.orderStatus);
              element.createTimeText= this.dayjs(element.createTime*1000).format('YYYY-MM-DD HH:mm:ss ');
              element.repetitionRateText = (element.repetitionRate * 100).toFixed(2) + "%"
      // this.orderInfo.updateTimeText= this.dayjs(this.orderInfo.updateTime*1000).format('YYYY-MM-DD HH:mm:ss ');         
          }
          this.tableData=data.list;
          this.pagination.total=data.total*1;
          this.isLoading = false
          
        });
    },
    sizeChange (pageSize) {
      this.pageSize = pageSize
      this.pageNum = 1
      this.fetchData()
    },
    currentChange (pageNum) {
      // 更新表格数据
      this.fetchData()
    },


    // 放大证书
    getRegisterImg(orderNo){
      queryRegisterOrder(orderNo).then(({ data }) => {
        // console.log("查重详情：",data);
        document.body.style.overflow = 'hidden';
        this.showImageUrl = data.certificateInfo.jpgUrl;
        this.showImageViewer = true;
      })
    },
    closePre(){
      document.body.style.overflow = 'auto';
      this.showImageUrl = '';
      this.showImageViewer = false;
    },


    // 获取存证图片
    getExistImg(orderNo){
      // console.log(orderNo);
      queryExistOrder(orderNo).then(({ data }) => {
        // console.log("存证详情：",data);
        document.body.style.overflow = 'hidden';
        this.showImageUrl2 = data.certificateInfo.jpgUrl;
        this.showImageViewer2 = true;
      })
    },
    closePre2(){
      document.body.style.overflow = 'auto';
      this.showImageUrl2 = '';
      this.showImageViewer2 = false;
    },

    //  下载报告
    download(zip){
      window.open(zip, "_self");  //_self，是不用打开新窗口
    },

    // 重新付款
    RepayAgain(row){
      // console.log('00000000000000--------------------',row);
      // 重新付款接口（不同于支付接口）
      queryCheckPaymentOrder(row.orderNo).then(({ data }) => {
        // that.order = data;
        // console.log("check::::::::::::",data);
        this.Info = data;
        // if (data.paymentStatus == "21") {   // 21是已经支付成功
        if (data.orderStatus == "12") {   // 12是已经支付成功，正在检测中
          this.bus.$emit("refreshVip");
          this.onSetPayDialogClose(true);
        } else {
          this.$refs.payDialog.showDialog(data);
          this.isPayDialogVisible = true;
        }
      });
    },
    onSetPayDialogClose(result) {
      console.log('支付成功result:',result);
      // 如果支付成功，跳转到详情页面
      if (result) {
        this.$router.push({
          path: "/Mine/MyCheck",
          // query: { orderNo: this.Info.orderNo },
        });
      }
    },

  }
}
</script>

<style lang='scss' scoped>
@import '../../../assets/css/mine.scss';
.myCheckBtn{color: #1884FF;background: transparent;padding: 0;border: none;margin: 0;display: inline-block;margin-right: 15px;}
.myCheckBtn:last-child{margin-right: 0;}
.myCheckBtn:hover,.myCheckBtn:focus{background: transparent;}
.myCheckBtn2{background: transparent;padding: 0;border: none;margin: 0;display: inline-block;}
.myCheckBtn2:hover{background: transparent;color: #C0C4CC;}
.myCheckBtn:disabled{color: #C0C4CC;}

@media screen and (max-width: 991px){
    .serviceMain{padding: 20px;}
    .searchBar{display: block;}
    .searchBar .tittle{margin-bottom: 10px;}
  }
</style>
